import { render, staticRenderFns } from "./ProductFeedRemarks.vue?vue&type=template&id=412e668b&scoped=true&"
import script from "./ProductFeedRemarks.vue?vue&type=script&lang=js&"
export * from "./ProductFeedRemarks.vue?vue&type=script&lang=js&"
import style0 from "./ProductFeedRemarks.vue?vue&type=style&index=0&id=412e668b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "412e668b",
  null
  
)

export default component.exports